import * as React from 'react'
// components
import {
  KPIFullModal,
  ActionFullModal,
  KPIMinimizedModal,
  ObjectiveFullModal,
  ActionMinimizedModal,
  ObjectiveMinimizedModal
} from 'components/Modals/PlanItems/index'
import AddLinkModal from 'components/Modals/AddLinkModal'
import SetResultRowModal from 'components/Modals/SetResultRowModal'
import ReviewDetailsModal from 'components/Modals/ReviewResultModal'
import ResourceCreateModal from 'components/Modals/ResourceModal/index'
import CreateReviewContainer from 'containers/Review/CreateReview'
import SelectMultiValueModal from 'components/Modals/SelectMultiValueModal/index'
import ConfirmUnlinkPlanItemModal from 'components/Modals/ConfirmUnlinkPlanItem'
import CreateScheduledReviewModal from 'components/Modals/CreateScheduledReviewModal'
import TwoFactorSetupModal from 'components/Modals/TwoFactorSetupModal'
import TwoFactorDisableModal from 'components/Modals/TwoFactorDisableModal'
import TwoFactorRegenerateCodesModal from 'components/Modals/TwoFactorRegenerateCodesModal'
import TwoFactorAdminResetModal from 'components/Modals/TwoFactorAdminResetModal'

const PageModals: React.FC = () => {
  return (
    <>
      <AddLinkModal />
      <KPIFullModal />
      <ActionFullModal />
      <SetResultRowModal />
      <KPIMinimizedModal />
      <ReviewDetailsModal />
      <ObjectiveFullModal />
      <ResourceCreateModal />
      <ActionMinimizedModal />
      <SelectMultiValueModal />
      <CreateReviewContainer />
      <ObjectiveMinimizedModal />
      <ConfirmUnlinkPlanItemModal />
      <CreateScheduledReviewModal />
      <TwoFactorSetupModal />
      <TwoFactorDisableModal />
      <TwoFactorRegenerateCodesModal />
      <TwoFactorAdminResetModal />
    </>
  )
}

export default PageModals
